import { render } from "./RadioList.vue?vue&type=template&id=a3904e08&scoped=true&ts=true"
import script from "./RadioList.vue?vue&type=script&lang=ts"
export * from "./RadioList.vue?vue&type=script&lang=ts"

import "./RadioList.vue?vue&type=style&index=0&id=a3904e08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3904e08"]])

export default __exports__